import Ajv, { AnySchema, ValidateFunction } from "ajv/dist/2020";
import AjvFormats from "ajv-formats";
import AjvKeywords from "ajv-keywords";
import def from "ajv-keywords/dist/definitions/dynamicDefaults";
import instanceofDef from "ajv-keywords/dist/definitions/instanceof";
import { v4 } from "uuid";

import { JsonSchemaValidatorError } from "./json-schema-validator.error";

def.DEFAULTS["uuid"] = () => v4;
/**
 * @deprecated use new keyword syntax instead
 */
instanceofDef.CONSTRUCTORS[Error.name] = Error;

/**
 * @deprecated use new keyword syntax instead
 */
if (typeof File !== "undefined") {
  instanceofDef.CONSTRUCTORS[File.name] = File;
}

export class JsonSchemaValidator {
  static readonly isFile = "isFile";
  static readonly isBuffer = "isBuffer";

  static ajv = AjvFormats(
    AjvKeywords(
      new Ajv({
        verbose: true,
        keywords: [
          {
            keyword: JsonSchemaValidator.isFile,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validate: (schema: any, data: any) => data instanceof File
          },
          {
            keyword: JsonSchemaValidator.isBuffer,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validate: (schema: any, data: any) => data instanceof Buffer
          }
        ]
      })
    )
  );

  static assert<T, R extends T = T>(
    validateFunction: ValidateFunction<unknown>,
    data: T
  ) {
    const valid = validateFunction(data);
    if (valid) {
      return data as unknown as R;
    }

    throw new Error(this.ajv.errorsText(validateFunction.errors));
  }

  static compile<T extends AnySchema>(
    schema: T,
    /**
     * @deprecated use new keyword syntax instead
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...classes: Array<new (...args: any[]) => any>
  ): ValidateFunction<T> {
    classes.forEach((_) => (instanceofDef.CONSTRUCTORS[_.name] = _));
    return JsonSchemaValidator.ajv.compile(schema);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static validate<T, R = T>(validateFunction: ValidateFunction<any>, data: T) {
    const valid = validateFunction(data);
    if (valid) {
      return data as unknown as R;
    }

    throw new JsonSchemaValidatorError(
      this.ajv.errorsText(validateFunction.errors)
    );
  }
}
